import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import emptyFunction from 'react-utils/emptyFunction';
import { useUpgradePoint } from 'ui-addon-upgrades/ums/useUpgradePoint';
import { LockedIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GetStartedButton = ({
  onTrack = emptyFunction
}) => {
  const {
    openUpgradePage
  } = useUpgradePoint('calling-free-account-upgrade');
  const handleClick = useCallback(() => {
    onTrack();
    openUpgradePage();
  }, [onTrack, openUpgradePage]);
  return /*#__PURE__*/_jsxs(Button, {
    use: "primary",
    onClick: handleClick,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: `calling-orchestration-shared-library.unlock-calling.free-account-blocking.get-started-button-text`
    }), /*#__PURE__*/_jsx(LockedIcon, {})]
  });
};